/** @format */

import i18n from 'i18next';
// import Backend from 'i18next-xhr-backend';
// import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import resourcesToBackend from 'i18next-resources-to-backend';
// import translationEN from '../src/locales/en/translation.json';
// import translationDE from '../src/locales/en/translation.json';
// // the translations
// const resources = {
//   en: {
//     translation: translationEN
//   },
//   de: {
//     translation: translationDE
//   }
// };


export const availableLanguages = [
  'en',
  'de',
  'fr',
  'es',
  'it',
  'pl',
  'de-AT',
  'de-CH',
  'en-GB',
  'cs'
];

export const normalizeLocale = locale => {
  if (!locale || typeof locale !== 'string') {
    return null;
  }

  const normalized = locale.replace('_', '-').trim();
  const lower = normalized.toLowerCase();

  if (lower === 'de-de') {
    return 'de';
  }

  const exact = availableLanguages.find(language => language.toLowerCase() === lower);
  if (exact) {
    return exact;
  }

  const base = lower.split('-')[0];
  const byBase = availableLanguages.find(language => language.toLowerCase() === base);
  return byBase || null;
};

const getLocaleFileName = language => String(language || '').toLowerCase().replace('_', '-');

i18n
  // load translation using http -> see /public/locales
  // learn more: https://github.com/i18next/i18next-http-backend
  // .use(Backend)

  .use(
    resourcesToBackend((language, namespace, callback) => {
      const fileName = getLocaleFileName(language);
      import(`./locales/${fileName}.json`)
        .then(resources => {
          callback(null, resources);
        })
        .catch(error => {
          callback(error, null);
        });
    })
  )
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: 'en',
    // resources,
    debug: false,
    supportedLngs: availableLanguages,
    nonExplicitSupportedLngs: true,
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      convertDetectedLanguage: lng => normalizeLocale(lng) || 'en'
    },
    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    }
  });

export default i18n;
